var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column vh-100 p-2 bg-dark text-white"},[_c('div',{staticClass:"d-flex flex-row align-items-stretch justify-content-center",staticStyle:{"flex":"1"}},[_c('div',{staticClass:"justify-content-center w-100"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }